import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './AnonMenu.module.less';
import { Button } from 'edcom-ui';
import { openLogin, openSignup } from '../../../services/regModal';

export default function AnonMenu({ hamburgerOpen }) {
  return (
    <div
      className={clsx(styles.AnonMenu, hamburgerOpen && styles.hamburgerOpen)}
    >
      <a
        className={styles.login}
        data-trigger="topnav"
        onClick={e => {
          e.preventDefault();
          openLogin('topnav');
        }}
      >
        Log In
      </a>
      <Button
        color={'teal'}
        href={''}
        className={styles.register}
        onClick={e => {
          e.preventDefault();
          openSignup('topnav', { signUp: { title: null } });
        }}
      >
        Sign Up
      </Button>
    </div>
  );
}

AnonMenu.propTypes = {
  hamburgerOpen: PropTypes.bool,
};
